import { gql } from 'apollo-angular';

export const competenceCertificateMinimalFragment = gql`
  fragment CompetenceCertificateMinimal on CompetenceCertificate {
    id
    competenceCertificateLevel
    competenceCertificateStatus
    updatedAt
    createdAt
    supervisorApprovedAt
  }
`;

export const courseMinimalFragment = gql`
  fragment CourseMinimal on Course {
    id
    shortName
    title
  }
`;

export const generatedReportMinimalFragment = gql`
  fragment GeneratedReportMinimal on GeneratedReport {
    id
    createdAt
    generatedReportStatus
    reportType
    fileUrl
    portfolioFormat {
      id
      name
    }
  }
`;

export const interviewMinimalFragment = gql`
  fragment InterviewMinimal on Interview {
    id
    title
    date
    interviewStatus
    canAccess
    isYearlyAssessment
    supervisorApprovedAt
    ownerApprovedAt
    reductionDelta
    sourceAttributes
  }
`;

export const kpbItemMinimalFragment = gql`
  fragment KpbItemMinimal on KPB {
    id
    title
    date
    kpbStatus
    level
  }
`;

export const organizationMinimalFragment = gql`
  fragment OrganizationMinimal on Organization {
    id
    name
    createdAt
    isRoot
    parentId
  }
`;

export const organizationUserRoleMinimalFragment = gql`
  fragment OrganizationUserRoleMinimal on OrganizationUserRole {
    id
    canManageRoles
    canViewReports
  }
`;

export const portfolioFormatMinimalFragment = gql`
  fragment PortfolioFormatMinimal on PortfolioFormat {
    id
    shortName
    name
    mailingType
    canHaveResidencies
    educationDurationStartMonth
    nominalDuration
    onboardingShowProfile
    onboardingShowProfileGoals
    profileAllowCustom
    profiles
    usesProfile
    usesProfileGoals
    usesPortfolioNotes
    usesStartEndDate
    config
    rootCourse {
      id
      shortName
    }
  }
`;

export const portfolioMinimalFragment = gql`
  fragment PortfolioMinimal on Portfolio {
    id
    portfolioStatus
    archivedAt
    cohort
    educationStartedOn
    educationEndedOn
    toBeRemovedAt
    profile
  }
`;
export const programRoleMinimalFragment = gql`
  fragment ProgramRoleMinimal on ProgramRole {
    id
    name
    shortName
    roleType
    createdAt
    automaticallyCreatePortfolioRole
  }
`;

export const secondFactorMinimalFragment = gql`
  fragment SecondFactorMinimal on SecondFactor {
    id
    otp
    createdAt
  }
`;

export const securityQuestionMinimalFragment = gql`
  fragment SecurityQuestionMinimal on SecurityQuestion {
    answer
    id
    question
    createdAt
  }
`;

export const userMinimalFragment = gql`
  fragment UserMinimal on User {
    id
    isMe
    hasValidPin
    firstName
    lastName
    fullName
    isOnboarded
    avatarUrl
    thumbUrl
    canUseBetaFeatures
  }
`;
